export const HOSTAPP = {
    TX: 'TX',
    PARTNER_DASH: 'PARTNER_DASH',
    OWNER_LOGIN: 'OWNER_LOGIN',
    LYP: 'LYP'
};
